import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  history,
  isCommentaryOnlyUser,
  COMMENTARY_ALLOWED_PATHS,
} from "../utils/basicHelpers";
import { isEmpty } from "lodash";

const PrivateRoute = () => {
  const auth = useSelector((x) => x.auth.value);
  const loc = useLocation();

  // A commentary-only user is blocked from every page outside the commentary
  // panel with a plain not-authorised message.
  if (!isEmpty(auth) && isCommentaryOnlyUser(auth)) {
    const allowed = COMMENTARY_ALLOWED_PATHS.some((p) =>
      loc.pathname?.startsWith(p)
    );
    if (!allowed) {
      return <>You are not authorised to access this page.</>;
    }
  }

  const blackListUrls = [
    "/users",
    // "/users/add",
    // "/users/update",
    // "/users/permission",
    "/countries",
    // "/countries/add",
    // "/countries/update",
    "/seasons",
    // "/seasons/add",
    // "/seasons/update",
    // "/seasons/detail",
    "/languages",
    // "/languages/add",
    // "/languages/detail",
    // "/languages/update",
  ];
  
  const result = blackListUrls.some(path => loc.pathname?.includes(path));
  if (
    result &&
    !auth?.roles?.includes("ADMIN")
  ) {
    return <>Un-Authorized access</>;
  }
  if (isEmpty(auth)) {
    return <Navigate to="/" state={{ from: history.location }} />;
  }

  return <Outlet />;
};

export default PrivateRoute;
